import PageShell from '../components/technical/PageShell/PageShell.tsx';
import ManagementDashboard from '../components/management/ManagementDashboard.tsx';
import AccountList from '../components/portfolio/account/list/AccountList.tsx';
import SubFundsDashboardContainer from '../components/portfolio/fund/SubFundsDashboard.tsx';
import AssetGroupsDashboard from '../components/market/asset/groups/AssetGroupsDashboard.tsx';
import AssetManagementList from '../components/market/asset/management/AssetManagementList.tsx';
import UserSettings from '../components/management/settings/UserSettings.tsx';
import PrivateRoute from './PrivateRoute/PrivateRoute.tsx';
import ImpersonationDashboard from '../components/management/impersonation/ImpersonationDashboard.tsx';
import NotificationSettings from '../components/copilot/newsNotification/NotificationSettings.tsx';
import PositionsEditor from '../components/portfolio/snapshotEditor/PositionsEditor.tsx';
import { createIndexRoute } from './CreateIndexRoute.tsx';
import CexCustodiansTab from '../components/portfolio/account/list/CexCustodiansTab.tsx';
import BlockchainWalletsTab from '../components/portfolio/account/list/BlockchainWalletsTab.tsx';
import ManualTab from '../components/portfolio/account/list/ManualTab.tsx';
import NonCryptoIntegrationsTab from '../components/portfolio/account/list/NonCryptoIntegrationsTab.tsx';
import IbkrCallback from '../components/portfolio/account/IbkrCallback.tsx';

export const managementRoutes = {
  handle: { breadcrumb: 'Management', title: 'Management' },
  path: 'management',
  children: [
    {
      path: 'dashboard',
      handle: { breadcrumb: 'Management' },
      element: (
        <PageShell title="Management" hideBottomPadding>
          <ManagementDashboard />
        </PageShell>
      ),
    },
    {
      handle: { breadcrumb: 'Accounts' },
      path: 'account',
      element: (
        <PageShell title="Accounts">
          <AccountList />
        </PageShell>
      ),
      children: [
        {
          handle: { breadcrumb: 'CEXs/Custodians' },
          path: 'cex',
          element: <CexCustodiansTab />,
        },
        {
          handle: { breadcrumb: 'Blockchain wallets' },
          path: 'blockchain',
          element: <BlockchainWalletsTab />,
        },
        {
          handle: { breadcrumb: 'Manual' },
          path: 'manual',
          element: <ManualTab />,
        },
        {
          handle: { breadcrumb: 'TradFi integrations' },
          path: 'non-crypto',
          element: <NonCryptoIntegrationsTab />,
        },
        {
          handle: { breadcrumb: 'New IBKR' },
          path: 'new-ibkr',
          element: <IbkrCallback />,
        },
        createIndexRoute('cex'),
      ],
    },
    {
      handle: { breadcrumb: 'Sub-funds' },
      path: 'sub-funds',
      element: (
        <PageShell title="Sub funds">
          <SubFundsDashboardContainer />
        </PageShell>
      ),
    },
    {
      path: 'asset-groups',
      handle: { breadcrumb: 'Groups' },
      element: (
        <PageShell title="Groups">
          <AssetGroupsDashboard />
        </PageShell>
      ),
    },
    {
      handle: { breadcrumb: 'Assets' },
      path: 'asset',
      element: (
        <PageShell title="Assets">
          <AssetManagementList />
        </PageShell>
      ),
    },
    {
      handle: { breadcrumb: 'Settings' },
      path: 'settings',
      element: (
        <PageShell title="Settings" hideBottomPadding>
          <UserSettings />
        </PageShell>
      ),
    },
    {
      handle: { breadcrumb: 'Impersonation' },
      path: 'impersonation',
      element: (
        <PrivateRoute
          to="../dashboard"
          element={
            <PageShell title="Impersonation">
              <ImpersonationDashboard />
            </PageShell>
          }
          shouldAllow={({ isImpersonating, isAdmin }) => isImpersonating || isAdmin}
        />
      ),
    },
    {
      handle: { breadcrumb: 'Notifications' },
      path: 'notification',
      element: (
        <PageShell title="Notifications">
          <NotificationSettings />
        </PageShell>
      ),
    },
    {
      handle: { breadcrumb: 'Positions' },
      path: 'positions',
      element: (
        <PageShell title="Positions">
          <PositionsEditor />
        </PageShell>
      ),
    },
    createIndexRoute('dashboard'),
  ],
};
